export const APP_FONT_FAMILY = 'Inter, Roboto, Helvetica, Arial, sans-serif';

export const APP_FONT_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Roboto:wght@400;500;700&display=swap';
